import { useState, cloneElement } from "react";

import Modal from "ui-components/Modal";
import Button from "ui-components/Button";
import Divider from "ui-components/Divider";

import DataFileTypes from "../Data-File-Types";

interface Props {
  as?: React.ElementType<any>;
  modalClickElem: React.ReactNode;
  fileId: string;
  enableDrop?: boolean;
  onTypeChange?: (column: string, col_type: "numeric" | "char" | "date") => any;
  onDropStatusChange?: (column: string, status: "keep" | "drop") => any;
  className?: string;
}

const DataFileTypesModal = ({
  as = "div",
  modalClickElem,
  fileId,
  enableDrop,
  onTypeChange,
  onDropStatusChange,
  className,
}: Props) => {
  const [show, setShow] = useState(false);

  // @ts-ignore
  const clickElem = cloneElement(modalClickElem, {
    onClick: () => setShow(true),
  });

  const Component = as;

  return (
    <>
      <Component className={className}>{clickElem}</Component>
      <Modal
        id={`set-types-for-${fileId}`}
        ariaLabel={`set-types-for-${fileId}`}
        show={show}
        handleClose={() => setShow(false)}
        title="Show Column Types"
      >
        <>
          <DataFileTypes
            fileId={fileId}
            enableDrop={enableDrop}
            onTypeChange={onTypeChange}
            onDropStatusChange={onDropStatusChange}
            orientation="vertical"
            showTitle={false}
          />
          <Divider />
          <p className="text-right">
            <Button color="gray" onClick={() => setShow(false)}>
              Exit
            </Button>
          </p>
        </>
      </Modal>
    </>
  );
};

export default DataFileTypesModal;
